import { Button } from '../../shared/ui/button';
import { AIResponseMarkdown } from '../../shared/ui/ai-response-markdown';

export function SIChoiceQuestion({ content, disabled, onAnswer }: {
  content: string; disabled: boolean; onAnswer: (answer: string) => void;
}) {
  let question: { question: string; options: string[] } | null = null;
  const prefix = '```quantis-question\n';
  if (content.startsWith(prefix) && content.endsWith('\n```')) {
    try {
      const parsed: unknown = JSON.parse(content.slice(prefix.length, -4));
      if (parsed && typeof parsed === 'object' && 'question' in parsed && 'options' in parsed
        && typeof parsed.question === 'string' && parsed.question.trim()
        && Array.isArray(parsed.options) && parsed.options.length >= 2 && parsed.options.length <= 4
        && parsed.options.every((option: unknown) => typeof option === 'string' && option.trim())) {
        question = { question: parsed.question, options: parsed.options };
      }
    } catch { /* Malformed content remains readable as ordinary markdown. */ }
  }
  if (!question) return <AIResponseMarkdown text={content} />;
  const current = question;
  return <div className="space-y-3"><p>{current.question}</p><div className="flex flex-wrap gap-2">
    {current.options.map(option => <Button key={option} variant="outline" disabled={disabled}
      onClick={() => onAnswer(`${current.question}\nMy choice: ${option}`)}>{option}</Button>)}
  </div></div>;
}
